import VitecUserProvider from './VitecUserContext';
import VitecUser from './VitecUser';

let Index = () => {
    return (
        <VitecUserProvider>
            <VitecUser />
        </VitecUserProvider>
    )
}

export default Index;